import { z } from "zod";
import { zodObjectWithTelemetry } from "@/telemetry/helpers/zod";
import { transportBrowserConfig } from "@/transport/config/browser";

export const agentClientConfig = zodObjectWithTelemetry({
  schema: z.object({
    transport: transportBrowserConfig.schema.prefault({ provider: "livekit" }),
    experimental: z.object().prefault({}),
  }),
  toTelemetry: (config) => {
    config.transport = transportBrowserConfig.toTelemetry(config.transport) as never;
    return config;
  },
});
